import { lazy } from "react";
import lazyLoad from "../utils/lazy-load";
import BookCreatorLayout from "@/core/layouts/book-creator-layout";
import AdminLayout from "@/core/layouts/admin-layout";
import { BookOpenIcon, ChartBarIcon, CircleStackIcon, HomeIcon, UsersIcon } from "@heroicons/react/24/outline";
import { HomeIcon as HomeIconSolid, BookOpenIcon as BookOpenIconSolid, ChartBarIcon as ChartBarIconIconSolid, UsersIcon as UsersIconSolid, CircleStackIcon as CircleStackIconSolid } from "@heroicons/react/24/solid";
export const navigationRoutes: Array<NavigationRouteObject> = [
    {
        name: "首页",
        icon: <HomeIcon />,
        active: <HomeIconSolid />,
        element: lazyLoad(lazy(() => import("@/views/admin/index"))),
        path: '/admin',
        meta: {
            title: "首页",
            requiresAuth: true,
        }
    },
    {
        name: "书架",
        icon: <BookOpenIcon />,
        active: <BookOpenIconSolid />,
        element: lazyLoad(lazy(() => import("@/views/admin/books"))),
        path: '/admin/books',
        meta: {
            title: "书架",
            requiresAuth: true,
        }
    }, {
        name: "统计",
        icon: <ChartBarIcon />,
        active: <ChartBarIconIconSolid />,
        element: lazyLoad(lazy(() => import("@/views/admin/statistics"))),
        path: '/admin/statistics',
        role: ["admin","super_admin"],
        meta: {
            title: "统计",
            requiresAuth: true,
        }
    },
    {
        name: "素材库",
        icon: <CircleStackIcon />,
        active: <CircleStackIconSolid />,
        element: lazyLoad(lazy(() => import("@/views/material-library"))),
        path: '/admin/material/:id?',
        active_path:'/admin/material',
        meta: {
            title: "素材库",
            requiresAuth: true,
        }
    },
    {
        name: "超管",
        icon: <UsersIcon />,
        active: <UsersIconSolid />,
        element: lazyLoad(lazy(() => import("@/views/manage-user"))),
        path: '/admin/manage',
        role: "super_admin",
        meta: {
            title: "用户管理",
            requiresAuth: true,
        }
    }
]

export default [
    {
        element: <AdminLayout />,
        children: navigationRoutes,
        meta: { title: '管理员', requiresAuth: true, },
    },
    {
        // path: '/index',
        element: <BookCreatorLayout />,
        children: [
            {
                element: lazyLoad(lazy(() => import("@/views/admin/login"))),
                path: '/login',
            }
        ],
        meta: { title: '登录', requiresAuth: false, },
    },
    {
        // path: '/index',
        element: <BookCreatorLayout />,
        children: [
            {
                element: lazyLoad(lazy(() => import("@/views/book-creator"))),
                path: '/creator',
            }
        ],
        meta: { title: '控制台', requiresAuth: true, },
    },
    {
        path: '/workbench',
        element: lazyLoad(lazy(() => import('@/views/work-bench'))),
        meta: { title: '工作台', requiresAuth: true, },
    },
    {
        path: '/admin/authentication',
        element: lazyLoad(lazy(() => import('@/views/admin/login'))),
        meta: { title: '身份校验', requiresAuth: true, },
    }
] as Array<RouteObject>;